import React from 'react';
import { Badge } from '../ui/Kit';
import { APPOINTMENT_TYPE_LABELS } from '../../lib/calendarUtils';

export function AppointmentTypeBadge({ type }) {
  const label = APPOINTMENT_TYPE_LABELS[type] || String(type || '').replace(/_/g, ' ') || '—';
  return (
    <span className="inline-flex items-center px-2 py-0.5 rounded-full text-[10px] font-semibold uppercase tracking-wide bg-[#00AAFF]/12 text-[#00AAFF]">
      {label}
    </span>
  );
}

export function AppointmentStatusBadge({ status }) {
  const s = String(status || '').toLowerCase();
  const map = {
    scheduled: { variant: 'primary', label: 'Scheduled' },
    confirmed: { variant: 'success', label: 'Confirmed' },
    completed: { variant: 'default', label: 'Completed' },
    cancelled: { variant: 'danger', label: 'Cancelled' },
    no_show: { variant: 'warning', label: 'No Show' },
  };
  const x = map[s] || { variant: 'default', label: status || '—' };
  return <Badge variant={x.variant}>{x.label}</Badge>;
}
